<div class="actions" *ngIf="checkedItems.length">
  <nb-select size="small" placeholder="اکشن">
    <nb-option value="1">تغییر نام</nb-option>
    <nb-option value="2">مجوزها</nb-option>
    <nb-option value="3">حذف</nb-option>
  </nb-select>
  <div class="action-number">
    {{ checkedItems.length }} مورد انتخاب شده است.
  </div>
</div>

<nb-card>
  <nb-card-body>
    <div class="header">
      <nb-checkbox
        [ngClass]="{
          show: checkedItems.length,
          hide: !checkedItems.length
        }"
        indeterminate
        (checkedChange)="toggleSelection($event)"
      ></nb-checkbox>
      <div class="name col-5">نام</div>
      <div class="type col-2">نوع</div>
      <div class="col-2">ایجادکننده</div>
      <div class="col-2">زمان به‌روز‌رسانی</div>
      <div class="col-1">بازدید</div>
    </div>
    <hr />
    <div *ngFor="let item of tableItems">
      <div class="table-row">
        <nb-checkbox
          [ngClass]="{
            show: checkedItems.length,
            hide: !checkedItems.length
          }"
          [checked]="isChecked(item)" 
          (checkedChange)="selectRow($event, item)"
        ></nb-checkbox>
        <div class="name col-5">
          <nb-icon class="item-icon" icon="clipboard-outline"></nb-icon>
          {{ item.name }}
          <nb-icon [ngClass]="{
            show: item.favorite,
            hide: !item.favorite
          }" class="star" [icon]='starIcon(item.favorite)' (click)="onStarClick(item.id)"></nb-icon>
        </div>
        <div class="type col-2">{{ item.type }}</div>
        <div class="col-2">{{ item.creator }}</div>
        <div class="col-2">{{ item.updateTime | ticksToDate }}</div>
        <div class="col-1 view">
          {{ item.views }}
          <div class="me-4">
            <nb-icon [nbContextMenu]="moreItems" class="more" icon="more-horizontal-outline"></nb-icon>
          </div>
        </div>
 
      </div>
      <hr />
    </div>
  </nb-card-body>
</nb-card>
